import { render, staticRenderFns } from "./AlipayFlowResult.vue?vue&type=template&id=2cc47ed0&scoped=true"
import script from "./AlipayFlowResult.vue?vue&type=script&lang=js"
export * from "./AlipayFlowResult.vue?vue&type=script&lang=js"
import style0 from "./AlipayFlowResult.vue?vue&type=style&index=0&id=2cc47ed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc47ed0",
  null
  
)

export default component.exports